import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const notificationsQueueSliceName = "notificationsQueue";

export interface NotificationsQueueState {
  notificationsQueue: NotificationItem[];
}

export interface NotificationItem {
  id: string;
  type: "success" | "error" | "info" | "warning";
  titleProps: NotificationTextProps;
  messageProps?: NotificationTextProps;
  duration?: number | null;
}

export interface NotificationTextProps {
  ns: string;
  i18nKey: string;
  values?: object;
}

const initialState: NotificationsQueueState = {
  notificationsQueue: [],
};

const notificationsQueueSlice = createSlice({
  name: notificationsQueueSliceName,
  initialState,
  reducers: {
    addNotification: (state: NotificationsQueueState, action: PayloadAction<NotificationItem | NotificationItem[]>) => ({
      notificationsQueue: [...state.notificationsQueue, ...(Array.isArray(action.payload) ? action.payload : [action.payload])],
    }),
    removeNotification: (state: NotificationsQueueState, action: PayloadAction<string | string[]>) => {
      const filterFunc = Array.isArray(action.payload)
        ? (item: NotificationItem) => !action.payload.includes(item.id)
        : (item: NotificationItem) => item.id !== action.payload;
      return ({
        notificationsQueue: state.notificationsQueue.filter(filterFunc),
      });
    },
  },
});

export interface NotificationsQueueRootState {
  [notificationsQueueSliceName]: NotificationsQueueState;
}

export const selectNotificationsQueue = (state: NotificationsQueueRootState) => state[notificationsQueueSliceName].notificationsQueue;

export const { addNotification, removeNotification } = notificationsQueueSlice.actions;
export const notificationsQueueReducer = notificationsQueueSlice.reducer;
